if (!customElements.get('tribe-footer-menu')) {
  customElements.define('tribe-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      queueMicrotask(() => {
        if (!this.isConnected || controller.signal.aborted) return;
        const details = this.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!details || !summary) return;
        const mobile = window.matchMedia('(max-width: 749px)');
        const options = { signal: controller.signal };
        const sync = () => {
          if (mobile.matches && details.contains(document.activeElement) && document.activeElement !== summary) {
            summary.focus();
          }
          details.open = !mobile.matches;
          summary.tabIndex = mobile.matches ? 0 : -1;
        };
        mobile.addEventListener('change', sync, options);
        summary.addEventListener('click', event => {
          if (!mobile.matches) event.preventDefault();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (this.closest('.footer-block')?.contains(event.target)) details.open = true;
        }, options);
        sync();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
